import script from "./ArchiveManagementView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ArchiveManagementView.vue?vue&type=script&lang=ts&setup=true"

import "./ArchiveManagementView.vue?vue&type=style&index=0&id=d5d7c560&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5d7c560"]])

export default __exports__